<template>
  <footer v-if="isMobileDevice" class="footer">
    <div v-if="noticeList.length > 0" class="footer-notice">
      <span class="footer-notice-icon">
        <router-link to="/customer/notice_list">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g fill="none" fill-rule="evenodd">
              <path d="M0 0h24v24H0z" />
              <path
                fill="#A5A5A5"
                d="M8.286 15.96h-.763a3.523 3.523 0 1 1 0-7.046h6.558l4.386-2.76A1 1 0 0 1 20 7.002v10.66a1 1 0 0 1-1.45.892L13.4 15.96h-3.113l1.533 5.404a.5.5 0 0 1-.48.636h-.961a.5.5 0 0 1-.481-.363L8.286 15.96z"
              />
              <circle cx="22" cy="2" r="2" fill="#E938C6" />
            </g>
          </svg>
        </router-link>
      </span>
      <swiper
        ref="footerNotice"
        :options="swiperOptions"
        @click.native="goNotice()"
      >
        <swiper-slide
          v-for="(notice, index) in noticeList"
          :key="'footer_notice' + index"
        >
          <span class="footer-notice-txt"> {{ notice.bottom_text1 }} </span>
        </swiper-slide>
      </swiper>
    </div>
    <div class="footer-menu">
      <div class="footer-icon">
        <a href="https://www.facebook.com/wavve.official/" target="_blank">
          <span class="footer-icon-img facebook"></span>
          <span class="a11y-hidden">Wavve 페이스북</span>
        </a>
        <a
          href="http://m.post.naver.com/my.nhn?memberNo=12375258"
          target="_blank"
        >
          <span class="footer-icon-img naver"></span>
          <span class="a11y-hidden">Wavve 네이버 포스트</span>
        </a>
      </div>
      <div class="footer-policy">
        <ul>
          <li>
            <router-link to="/agreement/service">이용약관</router-link>
          </li>
          <li class="footer-privacy">
            <router-link v-if="isWavveOn" to="/agreement/pooqzone_privacy"
              >웨이브온 개인정보 처리방침</router-link
            >
            <router-link v-else to="/agreement/privacy"
              >개인정보 처리방침</router-link
            >
          </li>
          <li :class="{ 'right-divider': !isWavveOn }">
            <router-link to="/customer/faq">고객센터</router-link>
          </li>
          <li v-if="!isWavveOn">
            <router-link to="/event/list">이벤트</router-link>
          </li>
        </ul>
      </div>
      <div class="footer-corp">
        <div>
          <span>콘텐츠웨이브 주식회사 / 대표이사: 이 헌</span>
          <span>
            <address>
              주소: 서울특별시 영등포구 여의나루로 60 포스트타워 15층
            </address>
          </span>
          <span>사업자등록번호 220-88-38020</span>
        </div>
        <div>
          <span>통신판매업 신고번호 : 제 2021-서울영등포-0585호</span>
          <span>
            통신판매업 정보 공개 :
            <a
              href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208838020"
              target="_blank"
            >
              https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208838020
            </a>
          </span>
          <span
            >호스팅서비스제공자 : 마이크로소프트 유한회사, 구글클라우드코리아
            유한회사, 아마존웹서비시즈코리아 유한회사</span
          >
        </div>
        <div>
          <span
            >고객센터 1599-3709 (평일 09:00~17:00 / 점심시간 12:00~13:00 / 주말
            및 공휴일 휴무) /
            <router-link class="info-link" to="/customer/user_qna"
              >1:1 문의</router-link
            >
          </span>
          <span
            >전자우편주소 :
            <a href="mailto:helpdesk@wavve.com">helpdesk@wavve.com</a></span
          >
        </div>
        <span>Copyright© 콘텐츠웨이브(주) All rights reserved.</span>
      </div>
    </div>
  </footer>
</template>

<script>
  import { FooterNoticeSerivce } from '@/common/api/api.service'
  import { get } from 'lodash'
  import utils from '@/common/util/utils'

  export default {
    name: 'Footer',
    data: () => {
      return {
        isWavveOn: utils.cookies.isPooqZone(),
        noticeList: [],
        swiperOptions: {
          allowTouchMove: false,
          autoplay: {
            delay: 3500,
            disableOnInteraction: false,
          },
          direction: 'vertical',
          loop: true,
          centeredSlides: true,
          slidesPerView: 1,
        },
      }
    },
    computed: {
      isMobileDevice() {
        return utils.cookies.getDevice() === 'mobile'
      },
    },
    created() {
      FooterNoticeSerivce.getNotices().then(({ data }) => {
        this.noticeList = get(data, ['top_list', '0', 'bottom_list'], [])
      })
    },
    methods: {
      goNotice() {
        const swiperIndex =
          this.$refs.footerNotice.swiper.clickedSlide.dataset.swiperSlideIndex
        const noticeNumber = this.noticeList[swiperIndex].bottom_link
          .split('=')
          .pop()
        this.$router.push(`/customer/notice_view/${noticeNumber}`)
      },
    },
  }
</script>

<style scoped>
  /*------------------------------------*\
      footer
  \*------------------------------------*/
  .footer {
    margin-bottom: 48px;
  }

  /* footer 공지사항 */
  .footer-notice {
    padding: 9px 10px;
    background-color: #161616;
  }
  .footer-notice a {
    display: block;
    width: 24px;
    height: 24px;
    font-size: 12px;
    line-height: 13px;
    color: #23212a;
  }
  .footer-notice-icon,
  .footer-notice-txt {
    display: inline-block;
    vertical-align: middle;
  }
  .footer-notice-icon {
    position: absolute;
  }
  .footer-notice-txt {
    margin-top: 3px;
    position: absolute;
    font-size: 12px;
    color: #a5a5a5;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .footer-notice .swiper-container {
    position: relative;
    width: 100%;
    height: 24px;
    padding-left: 34px;
  }

  /* footer menu > icon */
  .footer-menu {
    padding: 30px 10px 0;
    font-size: 12px;
    line-height: 14px;
    color: #717171;
  }
  .footer-icon a {
    display: inline-block;
    margin-right: 12px;
  }
  .footer-icon-img {
    display: block;
    content: '';
    width: 38px;
    height: 38px;
  }
  .footer-icon-img.facebook {
    background: url(/img/common/footer-icon-facebook.png);
    background-size: 38px 38px;
  }
  .footer-icon-img.naver {
    background: url(/img/common/footer-icon-naver.png);
    background-size: 38px 38px;
  }
  .footer-icon-img.youtube {
    background: url(/img/common/footer-icon-youtube.png);
    background-size: 38px 38px;
  }

  /* footer menu > 이용약관/개인정보 처리방침/고객센터 */
  .footer-policy li + li {
    padding-left: 10px;
  }
  .footer-policy li {
    display: inline-block;
    padding: 12px 0 8px;
  }
  .footer-policy li:nth-child(1):after,
  .footer-policy li:nth-child(2):after,
  .footer-policy li.right-divider:nth-child(3):after {
    display: inline-block;
    vertical-align: middle;
    content: '';
    width: 1px;
    height: 9px;
    margin-left: 10px;
    background-color: #3e3e3e;
  }
  .footer-policy a {
    display: inline-block;
    padding: 8px 0;
    font-size: 12px;
    line-height: 18px;
    color: #717171;
  }
  .footer-policy .footer-privacy a {
    font-weight: 700;
    color: #a5a5a5;
  }
  .info-link {
    font-weight: 700;
    text-decoration: underline;
  }

  /* footer menu > 회사정보 */
  .footer-corp > div {
    margin-bottom: 16px;
  }
  .footer-corp span + span {
    margin-top: 2px;
  }
  .footer-corp span {
    display: block;
    font-size: 12px;
    line-height: 18px;
  }
  .footer-corp address {
    font-style: normal;
  }
  .footer-corp a {
    color: #717171;
  }
</style>
